import { useAuth } from '@features/auth';
import { ActionMenu, Avatar, IconButton } from '@ntconsult/aluma-react';
import { LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function UserMenu() {
  const { t } = useTranslation(['auth', 'common']);
  const { user, logout, isLoggingOut } = useAuth();
  if (!user) return null;

  return (
    <ActionMenu
      align="right"
      trigger={
        <IconButton
          label={t('common:nav.userMenu')}
          variant="ghost"
          icon={<Avatar name={user.name} src={user.avatarUrl} size="sm" />}
        />
      }
    >
      <div className="px-3 py-2">
        <div className="text-sm font-medium">{user.name}</div>
        <div className="text-xs text-foreground-muted">{user.email}</div>
      </div>
      <ActionMenu.Separator />
      <ActionMenu.Item
        icon={<LogOut />}
        variant="danger"
        disabled={isLoggingOut}
        onClick={() => logout()}
      >
        {t('auth:logout')}
      </ActionMenu.Item>
    </ActionMenu>
  );
}
